var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrolley = function SvgTrolley(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "trolley_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17V5H2V3h4v12h15v2H4Zm2 5c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 6 18c.55 0 1.02.196 1.412.587C7.804 18.98 8 19.45 8 20s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 6 22Zm1-8V8h6v6H7Zm7 0V8h6v6h-6Zm3.587 7.413A1.926 1.926 0 0 1 17 20c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 19 18c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 19 22c-.55 0-1.02-.196-1.413-.587Z",
    fill: "currentColor"
  })));
};
export { SvgTrolley as ReactComponent };